import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

async function fetchContent() {
  try {
    const { data } = await api.get("/site-content");
    cache = data;
    listeners.forEach((fn) => fn(data));
    return data;
  } catch {
    return cache || {};
  }
}

export function useSiteContent() {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    listeners.add(setContent);
    if (!cache) fetchContent(); else setContent(cache);
    return () => listeners.delete(setContent);
  }, []);
  const reload = useCallback(() => fetchContent(), []);
  return { content: content || {}, reload };
}

export async function saveSiteContent(payload) {
  const { data } = await api.put("/site-content", payload);
  cache = data;
  listeners.forEach((fn) => fn(data));
  return data;
}
